var $class="se2--promo-call-to-action-block",$name="PromoCallToActionBlock",$path="app/components/PromoCallToActionBlock/index.js",$this={$class,$name,$path,};import lazyHandleOpenModalButtons from 'app/components/utilities/lazyHandleOpenModalButtons';

import shell from 'app/modules/shell';

import 'app/partials/image';

export default shell.registerComponent($this, ({ addEventListener, mount }) => {
  mount((element) => {
    lazyHandleOpenModalButtons(addEventListener, element);
  });
});
